import {i18n} from '@/plugins/i18n'

export const walletTransactionType = {
    CHARGE_BY_RELATED_MERCHANT: 100,
    CHARGE_BY_DO_PAYMENT: 101,
    CHARGE_BY_OAUTH2: 102,
    CHARGE_BY_DIRECT_PAYMENT: 103,
    CHARGE_BY_TRANSFER: 104,
    CHARGE_BY_BILL: 105,
    // CHARGE_BY_IVR_SETTLEMENT: 106,
    CHARGE_BY_IVR_TRANSACTION: 107,
    CHARGE_BY_COLLECTIVE_TO_WALLET: 108,
    CHARGE_BY_MARKETING_PROFIT: 109,
    CHARGE_BY_SETTLEMENT_REVERSAL: 110,
    CHARGE_BY_RECEIPT: 111,
    CHARGE_BY_RECEIPT_FINALLY: 112,
    CHARGE_BY_COLLECTIVE_ON_PAYMENT_HELPER_TO_WALLET: 113,
    CHARGE_BY_ALLOTMENT_PF_AGGREGATE: 114,
    CHARGE_BY_DEPOSIT_WITH_ID: 115,
    CHARGE_THROUGH_SHAPARAK_SETTLEMENT: 116,

    TRANSFER: 200,

    SETTLEMENT: 300,
    REFUND: 301,

    CUSTOM_WAGE_IBAN_INFO: 400
};

export const walletTransactionTypeStr = {
    CHARGE_BY_RELATED_MERCHANT: i18n.t(
        'wallets.label.charge_by_related_merchant'
    ),
    CHARGE_BY_DO_PAYMENT: i18n.t('wallets.label.charge_by_do_payment'),
    CHARGE_BY_OAUTH2: i18n.t('wallets.label.charge_by_oauth2'),
    CHARGE_BY_DIRECT_PAYMENT: i18n.t('wallets.label.charge_by_direct_payment'),
    CHARGE_BY_TRANSFER: i18n.t('wallets.label.charge_by_transfer'),
    CHARGE_BY_BILL: i18n.t('wallets.label.charge_by_bill'),
    CHARGE_BY_IVR_TRANSACTION: i18n.t(
        'wallets.label.charge_by_ivr_transaction'
    ),
    CHARGE_BY_COLLECTIVE_TO_WALLET: i18n.t(
        'wallets.label.charge_by_collective_to_wallet'
    ),
    CHARGE_BY_MARKETING_PROFIT: i18n.t(
        'wallets.label.charge_by_marketing_profit'
    ),
    CHARGE_BY_SETTLEMENT_REVERSAL: i18n.t(
        'wallets.label.charge_by_settlement_reversal'
    ),
    CHARGE_BY_RECEIPT: i18n.t('wallets.label.charge_by_receipt'),
    CHARGE_BY_RECEIPT_FINALLY: i18n.t(
        'wallets.label.charge_by_receipt_finally'
    ),
    CHARGE_BY_COLLECTIVE_ON_PAYMENT_HELPER_TO_WALLET: i18n.t(
        'wallets.label.charge_by_collective_on_payment_helper_to_wallet'
    ),
    CHARGE_THROUGH_SHAPARAK_SETTLEMENT: i18n.t(
        'wallets.label.charge_through_shaparak_settlement'
    ),
    CHARGE_BY_ALLOTMENT_PF_AGGREGATE: i18n.t(
        'wallets.label.charge_by_allotment_pf_aggregate'
    ),
    CHARGE_BY_DEPOSIT_WITH_ID: i18n.t(
        'wallets.label.charge_by_deposit_with_id'
    ),

    TRANSFER: i18n.t('wallets.label.transfer'),

    SETTLEMENT: i18n.t('wallets.label.settlement'),

    REFUND: i18n.t('wallets.label.refund'),

    CUSTOM_WAGE_IBAN_INFO: i18n.t('wallets.label.custom_wage_iban_info'),

    get(type) {
        let type_str = null;

        Object.keys(walletTransactionType).forEach((item) => {
            if (walletTransactionType[item] === type) {
                type_str = walletTransactionTypeStr[item];
            }
        });

        return type_str;
    }
};

export const walletTransactionTypeVariant = type => {
    switch (type) {
        case walletTransactionType.CHARGE_BY_RELATED_MERCHANT:
        case walletTransactionType.CHARGE_BY_DO_PAYMENT:
        case walletTransactionType.CHARGE_BY_OAUTH2:
        case walletTransactionType.CHARGE_BY_DIRECT_PAYMENT:
        case walletTransactionType.CHARGE_BY_TRANSFER:
        case walletTransactionType.CHARGE_BY_BILL:
        case walletTransactionType.CHARGE_BY_IVR_SETTLEMENT:
        case walletTransactionType.CHARGE_BY_IVR_TRANSACTION:
        case walletTransactionType.CHARGE_BY_COLLECTIVE_TO_WALLET:
        case walletTransactionType.CHARGE_BY_MARKETING_PROFIT:
        case walletTransactionType.CHARGE_BY_SETTLEMENT_REVERSAL:
        case walletTransactionType.CHARGE_BY_DEPOSIT_WITH_ID:
            return 'success';
        case walletTransactionType.TRANSFER:
            return 'secondary';
        case walletTransactionType.SETTLEMENT:
        case walletTransactionType.REFUND:
        case walletTransactionType.CUSTOM_WAGE_IBAN_INFO:
            return 'primary';
    }

    return 'warning';
};
